<div class="toast-container position-fixed top-0 start-50 translate-middle-x p-3">
    <div class="toast" #alertConfirmToast role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-body">
            <span [innerHTML]="confirmationMessage"></span>
            <br>
            <div class="d-flex justify-content-center align-content-center pt-2 gap-1  border-top">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="toast"
                    (click)="modalClose()">Annulla</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="toast"
                    (click)="modalConfirmEvt()">Conferma</button>
            </div>
        </div>
    </div>
</div>